export default {
  json: {
    base: 'https://delay.trafficinfo.westjr.co.jp/api/fr/v1'
  },
  api: {
    base: 'https://delay.trafficinfo.westjr.co.jp/api/fr/v1'
  },
  external: {
    base: 'https://delay.trafficinfo.westjr.co.jp/api/fr/v1/ext'
  }
}



// WEBPACK FOOTER //
// ./src/configs/production.js